import { DialogStyle } from '../../elements/components/dialog/entities/dialog.entity';

export class DialogConfig<D = any> {
    data?: D;
    title?: string;
    options?: DialogConfigOptions;

    constructor(title?: string, data?: D, options?: DialogConfigOptions) {
        this.title = title;
        this.data = data;
        this.options = options;
    }
}

interface DialogConfigOptions {
    style?: DialogStyle;
    canCloseDialogOnNavigationEvent?: boolean;
}
